import React, { FC } from "react"
import { Card } from "../common/card"
import TyppingEffect from "./typing-effect"
import TypingEffect from "./typing-effect"
import AddNewQuery from "./add-new-query"
import axios from "axios"
import ConversationItem from "./conversation-item"
interface Props {
  history: Object
}
const Conversation = () => {
  const [data, setData] = React.useState<any[]>([])
  return (
    <div className='max-h-[70vh] overflow-auto sm:max-w-[900px]'>
      {data.map((entry, index) => (
        <ConversationItem
          key={index}
          entry={entry}
          isLast={index === data.length - 1} // Apply typing effect only to the last response.
        />
      ))}
      <AddNewQuery setData={setData} />
    </div>
  )
}

export default Conversation
